/**
 * list of dumy errors in english
 */
export const listOfErrors: string[] =
    [
        "File is too big. Max file size allowed is 80mb.",
        "File's type is not allowed.",
        "Max amount of files (28) has been reached."
    ];